import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import "./scss/design-system.scss";

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

Vue.filter("formatDate", function (value) {
  if (!value) return "";
  return new Date(value).toLocaleDateString();
});

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      if (token.startsWith("Bearer ")) {
        config.headers["Authorization"] = token;
      } else {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 403) {
        store.dispatch("login/logout");
        router.replace("/");
      } else if (error.response.status === 500) {
        console.log("status 500 auth");
      }
    }
    return Promise.reject(error);
  },
);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
